import { render, staticRenderFns } from "./basicInformationList.vue?vue&type=template&id=500b1b05"
import script from "./basicInformationList.vue?vue&type=script&lang=js"
export * from "./basicInformationList.vue?vue&type=script&lang=js"
import style0 from "./basicInformationList.vue?vue&type=style&index=0&id=500b1b05&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports